import type { ReactNode } from 'react';

export const symbol_map_search: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M638-511v-1.5 1.5-189 189ZM170-142q-17 9-33.5-1T120-173v-558q0-13 7.5-23t19.5-15l182-64q10-4 20-3.5t20 3.5l243 85 178-71q17-8 33.5 1.5T840-788v359q0 13-8.5 21t-21.5 8q-13 0-21.5-8.5T780-430v-324l-142 54v172q0 13-8.5 21.5T608-498q-13 0-21.5-8.5T578-528v-172l-196-66v509q0 14-7.5 25.5T354-215l-184 73Zm10-65 142-54v-505l-142 47v512Zm538-31q26-26 26-64t-26-64q-26-26-64-26t-64 26q-26 26-26 64t26 64q26 26 64 26t64-26Zm-64 86q-62 0-106-44t-44-106q0-63 44-106.5T654-452q63 0 106.5 43.5T804-302q0 23-6.5 44T779-219l82 82q8 8 8 19t-8 19q-8 8-19 8t-19-8l-82-81q-19 14-40.5 21t-46.5 7ZM322-766v505-505Z"
		/>
	</svg>
);
